import React from 'react'

import * as S from './ProductBanners.styled'
import type { UseProductBanners } from './hooks/useProductBanners'

export const ProductBanners = ({ productBanners }: UseProductBanners) => {
  if (productBanners.length === 0) {
    return null
  }

  return (
    <S.Container>
      {productBanners.map((component, index) => (
        <S.Banner key={index}>{component}</S.Banner>
      ))}
    </S.Container>
  )
}
